<template>
  <header class="bmd-layout-header">
    <div class="navbar navbar-light bg-faded">
      <button class="navbar-toggler" type="button" data-toggle="drawer" data-target="#dw-s1">
        <span class="sr-only">Toggle drawer</span>
        <i class="fas fa-bars"></i>
      </button>
      <ul class="nav navbar-nav">
        <li class="nav-item">{{usuario.nombre}}
          <span id="cerra-sesion" data-toggle="tooltip" data-placement="bottom"
                title="Cerra sesion" @click="handleLogout()" style="cursor: pointer">
            <i class="fas fa-sign-out-alt"></i>
          </span>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import authService from '../auth/auth.Service';

  export default {
    name: "barraSuperior",
    data() {
      return {
        usuario: {}
      }
    },
    created() {
      let self = this;
      EventBus.$on('usuario', function (usuario) {
        self.usuario = usuario;
      });

        $('[data-toggle="tooltip"]').tooltip()

    },
    methods: {
      handleLogout() {
        authService.logout();
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/compartida/barraSuperior.vue